/* eslint-disable no-console */
import { LoaderFunction, redirect } from 'react-router-dom';

import apiClient from 'src/api';

export const loader: LoaderFunction = async ({ params }): Promise<Response> => {
  const courseId = params.courseId ?? '';

  // TODO: Replace with actual check from Contentful or Adobe API
  // For now, hardcoded to false (assume all courses are public)
  const isPrivate = false;

  // If private class, redirect to team-training page
  if (isPrivate) {
    return redirect(`/team-training/${courseId}`);
  }

  // If public class, redirect to enrolled or next upcoming session
  try {
    // Check for enrolled session first
    const res = await apiClient.adobe.getEnrollments({
      email: 'rknight@atlassian.com',
      aaid: '111',
    });

    if (res.data?.data) {
      const enrollment = res.data.data.find((item) => item.relationships?.learningObject?.data?.id === courseId);

      if (enrollment?.id) {
        // Parse ID format: "course:12547259_15145914_30579649"
        const idParts = enrollment.id.split(':')[1]?.split('_');
        const instanceId = idParts?.[1];

        if (instanceId) {
          console.log('redirecting to enrolled session with instance id', instanceId);

          return redirect(`/class/${courseId}/session/${instanceId}`);
        }
      }
    }

    // TODO: If not enrolled, fetch next upcoming session from Adobe API
    // For now, mock an upcoming session
    const mockUpcomingInstanceId = '12547259';

    if (mockUpcomingInstanceId) {
      console.log('redirecting to upcoming session with upcoming instance id', mockUpcomingInstanceId);

      return redirect(`/class/${courseId}/session/${mockUpcomingInstanceId}`);
    }

    // If no session found, throw 404
    throw new Response('No sessions found for this class', { status: 404 });
  } catch (error) {
    if (error instanceof Response) {
      throw error;
    }
    console.error('Error checking for sessions:', error);
    throw new Response('Unable to load class data', { status: 500 });
  }
};
